import { isMobilePhone } from 'class-validator';

/**
 * Strips formatting characters from a phone number, leaving digits only.
 * Regex `/[^\d]/g`: `[^\d]` matches any character that is not a digit (0-9); `g` removes all matches.
 */
export const sanitisePhoneNumber = (phoneNumber: string | null | undefined): string => {
  if (phoneNumber == null) {
    return '';
  }

  return phoneNumber.replace(/[^\d]/g, '');
};

/**
 * Validates if a given phone number is a valid Canadian or US mobile phone number.
 * Removes all non-digit characters before validation.
 * @param phoneNumber - The phone number to validate (10 digits).
 * @returns `true` if the phone number is valid for Canada ('en-CA') or the United States ('en-US'), otherwise `false`.
 */
export const isValidMobilePhone = (phoneNumber: string) => {
  const digitOnlyPhoneNumber = phoneNumber.replace(/\D/g, '');
  return (
    isMobilePhone(digitOnlyPhoneNumber, 'en-CA') || isMobilePhone(digitOnlyPhoneNumber, 'en-US')
  );
};
